import {
  ScoreTypeCreateInterface,
  ScoreTypeInterface,
  ScoreTypeRepositoryInterface,
} from '@/services/QC-V2/score-type/interfaces';
import { AxiosInstance } from 'axios';

export default class ScoreTypeRepository implements ScoreTypeRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async getAll(): Promise<ScoreTypeInterface[]> {
    const response = await this.axios.get('/qa-controller-v2/score/types');

    return response.data;
  }

  public async getOneById(id: number): Promise<ScoreTypeInterface> {
    const response = await this.axios.get(`/qa-controller-v2/score/types/${id}`);

    return response.data;
  }

  public async createScoreType(data: ScoreTypeCreateInterface): Promise<ScoreTypeInterface> {
    const response = await this.axios.post('/qa-controller-v2/score/types', data);

    return response.data;
  }

  public async updateScoreType(id: number, data: ScoreTypeCreateInterface): Promise<void> {
    const response = await this.axios.patch(`/qa-controller-v2/score/types/${id}`, data);

    return response.data;
  }
}
